import {
  COUNTRY_INDEX_PROP,
  COUNTRY_RISK_PROP,
  INDUSTRY_INDEX_PROP,
  INDUSTRY_RISK_PROP,
} from '@app/src/hooks/getAssessmentFilterLabel'
import type { FilterGroup } from '@app/src/pages/ResourceCollection/Filters/useFilters'

interface RiskStatusOption {
  label: string
  value: string | number
}

interface RiskFilter {
  type: string
  indexLabel: string
  riskLabel: string
}

export interface RiskFilterData {
  countryIndexLabel?: string
  countryRiskLabel?: string
  industryIndexLabel?: string
  industryRiskLabel?: string
  riskFilters: RiskFilter[]
}

export const useRiskFilterProcessor = (
  categoryFilters: FilterGroup[] | undefined,
  riskStatusOptions: RiskStatusOption[],
  countryOptions: RiskStatusOption[],
  industryOptions: RiskStatusOption[],
): RiskFilterData => {
  const getRiskIndexLabel = (indexFilter: FilterGroup | undefined, options: RiskStatusOption[]) => {
    const indexValue = indexFilter?.filters?.[0]?.value
    return indexValue ? options.find(option => option.value === Number(indexValue))?.label : undefined
  }

  const getRiskStatusLabel = (statusFilter: FilterGroup | undefined) => {
    const statusValue = statusFilter?.filters?.[0]?.value
    if (Array.isArray(statusValue) && statusValue.length > 0) {
      const labels = statusValue
        .map(val => riskStatusOptions.find(option => option.value === val)?.label)
        .filter(Boolean)
      return labels.length > 0 ? labels.join(', ') : undefined
    }
    return statusValue ? riskStatusOptions.find(option => option.value === statusValue)?.label : undefined
  }

  const countryIndexFilter = categoryFilters?.find(f => f.name === COUNTRY_INDEX_PROP)
  const countryRiskFilter = categoryFilters?.find(f => f.name === COUNTRY_RISK_PROP)
  const industryIndexFilter = categoryFilters?.find(f => f.name === INDUSTRY_INDEX_PROP)
  const industryRiskFilter = categoryFilters?.find(f => f.name === INDUSTRY_RISK_PROP)

  const countryIndexLabel = getRiskIndexLabel(countryIndexFilter, countryOptions)
  const countryRiskLabel = getRiskStatusLabel(countryRiskFilter)
  const industryIndexLabel = getRiskIndexLabel(industryIndexFilter, industryOptions)
  const industryRiskLabel = getRiskStatusLabel(industryRiskFilter)

  const riskFilters: RiskFilter[] = [
    ...(countryIndexLabel && countryRiskLabel
      ? [{ type: COUNTRY_RISK_PROP, indexLabel: countryIndexLabel, riskLabel: countryRiskLabel }]
      : []),
    ...(industryIndexLabel && industryRiskLabel
      ? [{ type: INDUSTRY_RISK_PROP, indexLabel: industryIndexLabel, riskLabel: industryRiskLabel }]
      : []),
  ]

  return {
    countryIndexLabel,
    countryRiskLabel,
    industryIndexLabel,
    industryRiskLabel,
    riskFilters,
  }
}
